import React, { Component } from "react";
import axios from "../../util/axios";
import WebhookFilter from "../../components/webhookmanagement/WebhookFilter";
import WebhooksTable from "../../components/webhookmanagement/WebhooksTable";
import { trackPromise } from "react-promise-tracker";
import moment from "moment";
import Back from "../../components/common/Back";
import Timezone from "../../components/common/Timezone";
import CobrandSelector from "../../components/cobrandselection/CobrandSelector";

class Webhooks extends Component {
  getCobrandById(cobrandId) {
    var cobrands = JSON.parse(localStorage.getItem("userData")).cobrands;
    var index = cobrands.findIndex(function(cobrand, i) {
      return cobrand.id.toString() === cobrandId;
    });
    return index > -1 ? cobrands[index] : cobrands[0];
  }

  state = {
    webhooks: [],
    totalCount: 0,
    rowsPerPage: 50,
    filter: false,
    cobrand: this.props.match
      ? this.getCobrandById(this.props.match.params.cobrandId)
      : JSON.parse(localStorage.getItem("userData")).cobrands[0],
    searchCriteria: "",
    noDataAvailable: false
  };

  componentDidMount() {
    //if (this.props.location && this.props.location.state) {
    //this.setState({ webhooks: this.props.location.state });
    //} else {
    const modifiedParams = {};
    let fromDate = moment()
      .subtract(6, "d")
      .format("MM-DD-YYYY");
    let toDate = moment().format("MM-DD-YYYY");
    var fromDateToconvert = moment(fromDate)
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");

    var toDateToconvert = moment(toDate)
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");

    modifiedParams.fromDate = moment.utc(moment(fromDateToconvert)).format();
    modifiedParams.toDate = moment.utc(moment(toDateToconvert)).format();

    trackPromise(
      axios
        .get(`/api/webhooks?skip=0&top=${this.state.rowsPerPage}`, {
          params: modifiedParams,
          headers: {
            Authorization: JSON.parse(localStorage.getItem("userData")).token,
            "Cobrand-Id": this.state.cobrand.id
          }
        })
        .then(res => {
          this.setState({
            webhooks: res.data.webhook,
            totalCount: res.data.totalCount
          });
          let defaultFromDate = moment()
            .subtract(6, "d")
            .format("MM-DD-YYYY");
          let defaultToDate = moment().format("MM-DD-YYYY");
          let searchCriteria =
            "Search results for From date: " +
            defaultFromDate +
            " and To Date: " +
            defaultToDate;
          this.setState({ searchCriteria });
          this.setState({ noDataAvailable: false });
          //this.props.history.push(this.props.location.pathname, this.state.webhooks);
        })
        .catch(err => {
          console.log(err);
        })
    );
    //}
  }

  async getWebhooks(rowsPerPage, page = 1) {
    const skipNum = (page - 1) * rowsPerPage;
    if (this.state.filter) {
      var params = this.state.filter;
      params.skip = skipNum;
      params.top = rowsPerPage;
    } else {
      var params = { skip: skipNum, top: rowsPerPage };
    }
    const modifiedParams = { ...params };

    //convert the dates to UTC before sending to server.
    if (modifiedParams.fromDate && modifiedParams.toDate) {
      var fromDateToconvert = moment(params.fromDate)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      var toDateToconvert = moment(params.toDate)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      modifiedParams.fromDate = moment.utc(moment(fromDateToconvert)).format();
      modifiedParams.toDate = moment.utc(moment(toDateToconvert)).format();
    }

    try {
      const response = await axios.get(`/api/webhooks`, {
        params: modifiedParams,
        headers: {
          Authorization: JSON.parse(localStorage.getItem("userData")).token,
          "Cobrand-Id": this.state.cobrand.id
        }
      });
      return response.data;
    } catch (error) {
      if (
        error.response.data.errorCode &&
        error.response.data.errorCode === "Y800"
      ) {
        this.setState({ noDataAvailable: true });
      }
    }
  }

  handlePageChange = async page => {
    const pageResp = await this.getWebhooks(this.state.rowsPerPage, page);
    await this.setState({ webhooks: pageResp.webhook });
  };

  handlePerRowsChange = async (perPage, page) => {
    this.setState({ rowsPerPage: perPage });
    const pageResp = await this.getWebhooks(perPage, page);
    this.setState({ webhooks: pageResp.webhook });
  };

  filter = async (webhookId, loginName, applicationId, fromDate, toDate) => {
    const params = {};
    let searchCriteria = "";

    if (webhookId) {
      params.webhookId = webhookId;
      searchCriteria = "WebhookId: " + webhookId;
    }
    if (loginName) {
      params.loginName = loginName;
      searchCriteria = searchCriteria + ", Login Name: " + loginName;
    }
    if (applicationId) {
      params.applicationId = applicationId;
      searchCriteria = searchCriteria + ", ApplicationId: " + applicationId;
    }
    if (fromDate) {
      params.fromDate = fromDate;
      searchCriteria =
        searchCriteria +
        ", From date: " +
        moment(fromDate).format("MM-DD-YYYY");
    }
    if (toDate) {
      params.toDate = toDate;
      searchCriteria =
        searchCriteria + ", To Date: " + moment(toDate).format("MM-DD-YYYY");
    }

    if (searchCriteria) {
      if (searchCriteria.lastIndexOf(",") > 1) {
        var commaPos = searchCriteria.lastIndexOf(",");
        searchCriteria =
          searchCriteria.substr(0, commaPos) +
          " and " +
          searchCriteria.substr(commaPos + 1, searchCriteria.length);
      }
      if (searchCriteria.indexOf(",") == 0) {
        searchCriteria = searchCriteria.substr(1, searchCriteria.length);
      }

      this.setState({ searchCriteria: "Search results for " + searchCriteria });
    } else {
      let defaultFromDate = moment()
        .subtract(6, "d")
        .format("MM-DD-YYYY");
      let defaultToDate = moment().format("MM-DD-YYYY");
      let searchCriteria =
        "Search results for From date: " +
        defaultFromDate +
        " and To Date: " +
        defaultToDate;
      this.setState({ searchCriteria });
    }

    await this.setState({ filter: params });
    const pageResp = await this.getWebhooks(this.state.rowsPerPage);
    if (pageResp) {
      this.setState({ noDataAvailable: false });
      await this.setState({
        webhooks: pageResp.webhook,
        totalCount: pageResp.totalCount
      });
    }
    //trackPromise(
    //axios.get('/api/webhooks', {
    //params: params,
    //headers: {
    //'Authorization': JSON.parse(localStorage.getItem('userData')).token,
    //'Cobrand-Id': this.state.cobrand.id
    //}
    //})
    //.then(res => {
    //this.setState({ webhooks: res.data.webhook });
    //this.props.history.replace(this.props.location.pathname, this.state.webhooks);
    //})
    //.catch(err => {
    //console.log(err);
    //})
    //);
  };

  render() {
    return (
      <div className="container main">
        <div className="row mt-4 mb-2">
          <div className="col-md-4 ml-auto">
            <CobrandSelector />
          </div>
        </div>
        <div class="heading mt-2 mb-4">Webhooks </div>
        <WebhookFilter filter={this.filter} />
        <div className="mb-1">{this.state.searchCriteria}</div>
        {!this.state.noDataAvailable && (
          <Timezone label="* Times are displayed in" />
        )}
        {this.state.noDataAvailable && (
          <div className="noData">There are no records to display</div>
        )}
        {!this.state.noDataAvailable && (
          <WebhooksTable
            data={this.state.webhooks}
            cobrand={this.state.cobrand}
            totalCount={this.state.totalCount}
            paginationPerPage={this.state.rowsPerPage}
            handlePerRowsChange={this.handlePerRowsChange}
            handlePageChange={this.handlePageChange}
          />
        )}
      </div>
    );
  }
}

export default Webhooks;
